import { useState, FC, ReactNode } from 'react'
import { endOfMonth, startOfMonth, getDay, getDate, setMonth, getMonth, addMonths, subMonths } from 'date-fns'

import { Format } from 'services/Dates'

import { Button as MerinioButton } from 'ui'

const Calendar: FC = () => {
  const [baseDate, setBaseDate] = useState(new Date())
  const today = getDate(new Date())
  const numberOfDaysThisMonth = getDate(endOfMonth(baseDate))
  const numberOfDaysPreviousMonth = getDate(endOfMonth(setMonth(baseDate, getMonth(baseDate) - 1)))
  const firstWeekday = getDay(startOfMonth(baseDate))
  const numberOfRows = Math.ceil((numberOfDaysThisMonth + firstWeekday) / 7)

  const createRows = () => {
    const rows: ReactNode[] = []
    let rowIndex = 0
    while (rowIndex < numberOfRows) {
      rows.push(<tr key={rowIndex}>{createCells(rowIndex * 7)}</tr>)
      rowIndex++
    }
    const weekDays = (
      <tr key="weekdays">
        {['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'].map(day => (
          <td key={day} className="text-muted">
            {day}
          </td>
        ))}
      </tr>
    )
    return [weekDays, ...rows]
  }

  const createCells = (start: number) => {
    const cells: ReactNode[] = []
    let cellIndex = 1
    while (cellIndex <= 7) {
      let currentDay = start + cellIndex - firstWeekday
      let classModifiers = ''
      if (currentDay === today) {
        classModifiers += ' font-weight-bold'
      } else {
        if (currentDay > numberOfDaysThisMonth || currentDay <= 0) classModifiers += ' text-muted'
        if (currentDay > numberOfDaysThisMonth) currentDay -= numberOfDaysThisMonth
        else if (currentDay <= 0) currentDay += numberOfDaysPreviousMonth
      }

      cells.push(
        <td key={currentDay} className={`calendar-day${classModifiers}`}>
          {currentDay}
        </td>
      )

      cellIndex++
    }
    return cells
  }

  return (
    <div>
      <div className="d-flex">
        <div>
          <MerinioButton color="secondary" onClick={() => setBaseDate(subMonths(startOfMonth(baseDate), 1))} outlined>
            <i className="fas fa-arrow-left"></i>
          </MerinioButton>
        </div>
        <h5 className="flex-grow-1 text-center">{Format(baseDate, { outFormat: 'monthAndYear' })}</h5>
        <div>
          <MerinioButton color="secondary" onClick={() => setBaseDate(addMonths(startOfMonth(baseDate), 1))} outlined>
            <i className="fas fa-arrow-right"></i>
          </MerinioButton>
        </div>
      </div>
      <table className="w-100 mt-2 mb-3">
        <tbody>{createRows()}</tbody>
      </table>
    </div>
  )
}

export default Calendar
